import { translateServerError } from '../../utils/i18n';

var timeOut = null;
const awaitTimeout = delay => new Promise(resolve => timeOut = setTimeout(resolve, delay));

export function toastError(message) {
    message = translateServerError(message);
    clearTimeout(timeOut);
    const error = document.querySelector('.toast__container.error');
    error.querySelector('.error-msg').textContent = message;
    error.classList.add('show');

    awaitTimeout(5000).then(closeErrorToast);

    document.querySelector('.toast__container.error .close-error').addEventListener('click', closeErrorToast);
}

function closeErrorToast() {
    const error = document.querySelector('.toast__container.error');
    error.addEventListener('transitionend', () => {
        error.querySelector('.error-msg').textContent = '';
    }, {once: true});
    error.classList.remove('show');
    clearTimeout(timeOut);
}
